<template>
  <div>
    <bill-appointments-list
      v-if="bill"
      :listTitle="'selectAppointments'"
      :billAppointmentsFullList="items"
      :selectedBillAppointments="bill.providedServices"
      @selectedbillappointmentsupdated="updateSelectedBillAppointments"
      ><slot slot="filters" name="filters"></slot
    ></bill-appointments-list>

    <v-row class="no-gutters justify-space-between">
      <v-col class="col-12 col-sm-auto mb-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          outlined
          rounded
          block
          :disabled="true"
          >{{ $t("billAppointments.otherAppointments") }}</v-btn
        >
      </v-col>
      <v-col class="col-12 col-sm-auto mb-3">
        <v-btn
          color="primary"
          class="caption font-weight-bold"
          :disabled="!hasBillAppointments"
          depressed
          rounded
          block
          @click="goToBillPage"
          >{{ $t("billAppointments.addToBill") }}</v-btn
        >
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import orderBy from "lodash/orderBy";
import BillAppointmentsList from "./BillAppointmentsList";

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    contentType: {
      type: String,
      required: true
    }
  },
  components: {
    BillAppointmentsList
  },
  data() {
    return {
      billId: "",
      bill: null
    };
  },
  created() {
    this.initialize();
  },
  computed: {
    hasBillAppointments() {
      return this.bill.providedServices.length > 0;
    },
    officeId() {
      return this.$store.getters["hfManagement/officeId"];
    }
  },
  methods: {
    initialize() {
      this.billId = this.$route.params.id;

      let billDetails = cloneDeep(
        this.$store.getters["bills/billDetails"](this.contentType, this.billId)
      );
      if (billDetails === null) {
        return this.$store
          .dispatch("bills/getBillDetailsById", {
            officeId: this.officeId,
            billId: this.billId
          })
          .then(bill => {
            this.bill = cloneDeep(bill);
          })
          .catch(error => {
            this.errorMsg = error;
          });
      } else {
        this.bill = billDetails;
      }
    },
    updateSelectedBillAppointments(selectedBillAppointments) {
      this.bill.providedServices = selectedBillAppointments;
    },
    goToBillPage() {
      this.bill.providedServices = orderBy(
        this.bill.providedServices,
        "appointmentId",
        "asc"
      );
      this.$store.commit("bills/setBillDetails", {
        contentType: this.contentType,
        billDetails: this.bill,
        billId: this.bill.id
      });

      this.$router.push({
        name: "billDetails",
        params: {
          id: this.bill.id
        }
      });
    }
  }
};
</script>
